/* Bad Earl — hero intro clip.
   Sequence: clip plays once -> black veil fades in over it -> clip is dropped
   -> veil clears, leaving the still image. Any failure falls straight through
   to the still, so the hero is never left blank. */
(function () {
  function setup(hero) {
    var video = hero.querySelector('.be-hero__intro');
    if (!video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish(hero, video);
      return;
    }

    var fadeSeconds = parseFloat(getComputedStyle(hero).getPropertyValue('--be-hero-fade')) || 1.2;
    var started = false;

    function beginFade() {
      if (started) return;
      started = true;
      hero.classList.add('is-intro-fading');
    }

    // Start the veil so it reaches full black exactly as the clip ends.
    video.addEventListener('timeupdate', function () {
      if (!video.duration || isNaN(video.duration)) return;
      if (video.currentTime >= video.duration - fadeSeconds) beginFade();
    });

    video.addEventListener('ended', function () {
      beginFade();
      hero.classList.add('is-intro-done');

      // Drop the clip first, then clear the veil, so the still is revealed
      // rather than the last frame flashing back.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.remove('is-intro-fading');
        });
      });
    });

    video.addEventListener('error', function () {
      finish(hero, video);
    });

    // Muted autoplay is usually allowed, but honour a refusal instead of
    // sitting on a frozen first frame.
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        finish(hero, video);
      });
    }
  }

  function finish(hero, video) {
    hero.classList.add('is-intro-done');
    hero.classList.remove('is-intro-fading');
    if (video && video.parentNode) video.parentNode.removeChild(video);
  }

  function init(root) {
    (root || document).querySelectorAll('.be-hero').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
